export default "__VITE_ASSET__CPxXBPMO__"